export default "__VITE_ASSET__CqzJkfDg__"